/**
 * Inject an inline <script> safely (avoids next/script + dangerouslySetInnerHTML
 * which can throw DOMException appendChild Unexpected token ';' in App Router).
 *
 * Uses textContent — never appendChild(Text) onto a script element.
 * Leaves the element in place (no cleanup remove) so third-party SDKs
 * are not torn down / re-inited on React Strict Mode remounts.
 *
 * Wraps appendChild so a syntax error in vendor code becomes a console
 * warning instead of Next.js red-box overlay.
 */
export function injectInlineScript(id: string, code: string): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.type = "text/javascript";
  script.textContent = code;
  try {
    document.head.appendChild(script);
  } catch (err) {
    console.warn(`[injectInlineScript] failed for #${id}`, err);
    script.remove();
  }
}

/** External SDK src — same Strict-Mode-safe insert as injectInlineScript. */
export function injectExternalScript(
  id: string,
  src: string,
  onLoad?: () => void,
): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  script.async = true;
  if (onLoad) script.onload = onLoad;
  try {
    document.body.appendChild(script);
  } catch (err) {
    console.warn(`[injectExternalScript] failed for #${id}`, err);
    script.remove();
  }
}
